define("calendar/components/calendar/stories/drop-zone", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="cDZ--dropzoneWrapper--stories ember-view"
    data-test-id="drop-zone"
    {{did-insert @scrollToRight}}
    {{droppable onDrop=@onDrop}}
  ></div>
  
  */
  {
    "id": "H7FGfRWK",
    "block": "[[[11,0],[24,0,\"cDZ--dropzoneWrapper--stories ember-view\"],[24,\"data-test-id\",\"drop-zone\"],[4,[38,0],[[30,1]],null],[4,[38,1],null,[[\"onDrop\"],[[30,2]]]],[12],[13],[1,\"\\n\"]],[\"@scrollToRight\",\"@onDrop\"],false,[\"did-insert\",\"droppable\"]]",
    "moduleName": "calendar/components/calendar/stories/drop-zone.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});